export default __webpack_public_path__ + "static/media/depot-menu.6762f53d.svg";